module.exports = "<!-- <div class=\"mobile-warning\"\n     translate>app.mobileWarning</div> -->\n\n<router-outlet></router-outlet>\n"